"use strict";

import initModulesInScope from "@elements/init-modules-in-scope";

export function initInScope ($scope) {
    let pendingRequest = null;

    $scope.find('.js-change-product__input').on('change', function (e) {
        e.preventDefault();


        let $container = $(this).closest('.js-change-product'),
            $loading = $container.find('.js-change-product__loading'),
            $error = $container.find('.js-change-product__error'),
            $result = $container.find('.js-change-product__result'),
            pushInHistory = $container.data('change-product-in-history')||false;

        if (pendingRequest) {
            pendingRequest.abort();
            pendingRequest = null;
        }

        let $this = $(this);
        let $form = $(this).closest('form');
        let ajaxUrl = $form.data('ajax-product-change-url');
        let data = $form.serialize();

        $result.attr('hidden', null);
        $loading.attr('hidden', null);

        pendingRequest = $.ajax(ajaxUrl, {
            dataType: 'json',
            data: data,
            cache: true
        }).done(function (response) {
            if (response.content){
                $result.empty().append(response.content);
                let href = $this.closest('.js-change-product__item').data('product-change-href');

                if (pushInHistory){
                    history.replaceState({}, '', window.location.origin + href);
                }
                initModulesInScope($result);
                let $scriptContainer = $container.find('.js-buy-local-script-container');
                // console.log('$scriptContainer', $scriptContainer);
                if ($scriptContainer.length) {
                    let scriptContainer = $scriptContainer[0];
                    let oldScript = scriptContainer.querySelector('script[data-outtrabrand_id]');
                    if(oldScript){
                        // Remove any existing script
                        oldScript.remove();
                    }
                    let gtins = scriptContainer.getAttribute('data-gtins');
                    let lang = scriptContainer.getAttribute('data-lang');
                    let script = document.createElement('script');
                    script.setAttribute('data-cookieconsent', 'ignore');
                    script.src = 'https://brandwidgets.outtra.com/js/martini-23/button-widget.js';
                    script.setAttribute('data-outtrabrand_id', '172');
                    script.setAttribute('data-gtins', gtins);
                    script.setAttribute('data-lang', lang);
                    script.async = true;
                    scriptContainer.appendChild(script);

                    // Add type="button" to outtra-modal-trigger-button after script loads
                    script.onload = function() {
                        setTimeout(function() {
                            let outtraButton = scriptContainer.querySelector('.outtra-modal-trigger-button');
                            // console.log('outtraButton', outtraButton);
                            if (outtraButton && !outtraButton.hasAttribute('type')) {
                                outtraButton.setAttribute('type', 'button');
                            }
                        }, 500);
                    };

                }

            }


        }).fail(function (jqXHR, textStatus, errorThrown) {
            if (textStatus !== 'abort') {
                $error.attr('hidden', null);
                console.error(textStatus, errorThrown, jqXHR);
            }
        }).always(function () {
            $loading.attr('hidden', 'hidden');
            pendingRequest = null;
        });

    });
    
}
$(document).ready(function() {
        let scriptContainer = document.querySelector('.js-buy-local-script-container');
        if (scriptContainer) {
            // Remove any existing script
            let oldScript = scriptContainer.querySelector('script[data-outtrabrand_id]');
            if (oldScript){
                oldScript.remove();
            }
            let gtins = scriptContainer.getAttribute('data-gtins');
            let lang = scriptContainer.getAttribute('data-lang');
            let script = document.createElement('script');
            script.setAttribute('data-cookieconsent', 'ignore');
            script.src = 'https://brandwidgets.outtra.com/js/martini-23/button-widget.js';
            script.setAttribute('data-outtrabrand_id', '172');
            script.setAttribute('data-gtins', gtins);
            script.setAttribute('data-lang', lang);
            script.async = true;
            scriptContainer.appendChild(script);
        }
});
